var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteWorkflow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.99996 1.59992C3.99996 0.716258 4.71636 -1.52588e-05 5.60001 -1.52588e-05H10.4C11.2837 -1.52588e-05 12.0001 0.716258 12.0001 1.59992V3.19998H13.5918H13.6067H15.2C15.6419 3.19998 16 3.5581 16 3.99995C16 4.4418 15.6419 4.80005 15.2 4.80005H14.3449L13.651 14.514C13.5913 15.3514 12.8946 16 12.0551 16H3.94485C3.1054 16 2.40868 15.3514 2.34895 14.514L1.65508 4.80005H0.799955C0.358115 4.80005 0 4.4418 0 3.99995C0 3.5581 0.358115 3.19998 0.799955 3.19998H2.39332H2.40818H3.99993L3.99996 1.59992ZM5.60001 3.19998H10.4V1.59992H5.60001V3.19998ZM3.94493 14.4002L3.25922 4.80005H12.7409L12.0552 14.4002H3.94493ZM6.39997 6.39998C6.84181 6.39998 7.20006 6.75824 7.20006 7.20009V12.0002C7.20006 12.442 6.84181 12.8001 6.39997 12.8001C5.95813 12.8001 5.60001 12.442 5.60001 12.0002V7.20009C5.60001 6.75824 5.95813 6.39998 6.39997 6.39998ZM10.4 7.20009C10.4 6.75824 10.0419 6.39998 9.60006 6.39998C9.15822 6.39998 8.79997 6.75824 8.79997 7.20009V12.0002C8.79997 12.442 9.15822 12.8001 9.60006 12.8001C10.0419 12.8001 10.4 12.442 10.4 12.0002V7.20009Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteWorkflow);
export default __webpack_public_path__ + "static/media/DeleteWorkflow.66009be9.svg";
export { ForwardRef as ReactComponent };